import TitleTextSection from "./TitelTextSection";
import LogoutLogic from "./utils/LogoutLogic";

const UserProfileBasicInfo = ({ profile }) => {
  return (
    <div className="bg-[#131313] p-6 my-6 card border border-white/10 rounded-2xl shadow-lg">
      <div className="flex justify-between pb-4 items-center border-b border-white/5 mb-4">
        <TitleTextSection title="Användarprofil" />
        <div className="flex gap-2.5">
          <a href="userprofile/editprofile">
            <button className="btn btn-outline border-white/20 text-white hover:bg-neutral-800 rounded-full font-bold uppercase tracking-wider text-xs px-5 py-3.5 transition-transform duration-300 hover:scale-105">
              Ändra
            </button>
          </a>
          <LogoutLogic />
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <h3 className="text-xl font-extrabold text-white uppercase tracking-wide">
          {profile.alias || profile.name}
        </h3>
        {profile.is_verified && (
          <div className="mt-1">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-success/15 text-[#22c55e] text-[10px] font-black tracking-wider uppercase border border-success/20">
              Verifierad
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfileBasicInfo;
